import { AnchorType, IAddProjectCoverContent, Tag } from '@brg/api';
import React, { FC, useMemo, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { 
  PresentationContainer,
  CheckboxRoot,
  PresentationWrapper,
  ContentLabel,
  CheckBoxInfoWrapper
} from './styles';
import { LayoutConst, } from 'core';
import { OrganizationsState } from 'shared/reducers/OrganizationsSlice';
import { MagicBox, FlexBox, FInter, HintTooltip } from '@brg/ui';
import { ReactComponent as CheckIcon } from "../../../../assets/check.svg";
import { ReactComponent as CheckWhite } from "../../../../assets/checkWhite.svg";
import { ProjectAuthorsChangeCbT } from '../../ProjectAuthorsEdit';
import { AuthorT } from '../../types';
import { ProjectEditPageGridInput } from '_deziiign/books/pages/BookEdit/styles';
import { CoverSettingsBlock } from './sections/CoverSettingsBlock';
import { ProjectSettingsBlock } from './sections/ProjectSettingsBlock';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import urlApi from 'shared/actions/urlApi';
import { useTranslation } from 'react-i18next';

export const INIT_ADDITIONAL_CONTENT: IAddProjectCoverContent = {
  title: {
    text: createDefaultLangObject(''),
    visible: true,
    color: '#000000'
  },
  subtitle: {
    text: createDefaultLangObject(''),
    visible: true,
    color: '#000000'
  },
  button: {
    text: createDefaultLangObject(''),
    color: '#000000',
    bgColor: '#000000',
    href: '',
    visible: false
  },
  anchors: {
    anchorVisible: undefined,
    anchorType: AnchorType.popup
  }
}

export interface IPresentation {
    currentColor: string;
    requiredTags: Tag[];
    projectTags: Tag[];
    isModer?: boolean;
    tagEntityRequired?: string[];
    coAuthors?: AuthorT[];
    contextRequiredTags?: string[];
    tagEntity?: string[];
    errorsArray?: string[];
    errorProjectFill?: boolean;
    longReadLength?: number;
    organizationEntity?: OrganizationsState;
    vTYPE: string;
    title?: any;
    isBilingual: boolean;
    hasCover?: boolean;
    projectTitle?: string;
    toggleHideTitle?: (e: any) => void;
    toggleHideInfo?: (e: any) => void;
    titleIsHidden?: boolean;
    projectInfoIsHidden?: boolean;
    onAdditionalContentChange?: (data: any) => void;
    onTitlePositionChange?: (pos: string) => void;
    titlePosition?: string;
    onCoauthorChange?: (data: ProjectAuthorsChangeCbT) => void;
    onColorChange: (val: string) => void;
    onSetRequiredTags: (tagsRaw: Tag[]) => void;
    onSetProjectTags: (tagsRaw: Tag[]) => void;
    onMakeBilingual?: () => void;
    onDisableBilingual?: () => void;
    onToggleBilingual?: () => void;
    availability?: string;
    additionalContent?: IAddProjectCoverContent,
    setAvailability?: (availability: string) => void;
    handleLinkCopy?: (e: any) => void;
    toggleAgeRestricted?: (e: any) => void;
    isAgeRestricted?: boolean;
    project?: any;
    incomingType?: any;
    proTags: string[],
    isTeamProject?: boolean,
    setProTags: (tagIds: string[]) => void;
}

type MagicBoxRowPropsT = {
    checked: boolean;
    label?: string;
    style?: any;
    onClick?: (ev: React.SyntheticEvent) => void;
    dark?: boolean;
    hintText?: string;
};

export const Footnote = styled(FInter.SmallTextDiv)`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const CopyLinkButton = styled(MagicBox)`
  cursor: pointer;
`

export const DropdownWrapper = styled(FlexBox)`
  ${ProjectEditPageGridInput} {
    width: 100% !important;

    .brg-input__control {
      background-color: #fff !important;
      
      &:hover {
        cursor: pointer;
        border-color: transparent !important;
      }  
    }
    
    input {
      width: 100% !important;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__menu {
      margin-top: 5px;
    }

    .brg-input__indicator {
      padding-top: 5px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s -1}px) {

    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__menu {
      margin-top: 5px;
    }

    .brg-input__indicator {
      padding-top: 5px;
    }
  }
`;


export const PresentationBlockTest: FC<MagicBoxRowPropsT> = ({ onClick, checked, label, style, dark, hintText }) => {

  const baseStyle = { padding: '2px 8px 4px', justifyContent: 'flex-start' };
  const geoStyle ={ background: "#E7E7E7", color: "#70706F", justifyContent: 'flex-start' }

  const combinedStyle = { ...baseStyle, ...geoStyle };

    return (<MagicBox
        onClick={onClick}
        width="100%"
        pointer
        align="center"
        gx={16}
    >
        <CheckboxRoot checked={checked} isProjectPage>
            {checked && (
                <>
                    {dark ? <CheckIcon/> : <CheckWhite/>}
                </>
            )}
            <input checked={checked} type="checkbox"/>
        </CheckboxRoot>
        <CheckBoxInfoWrapper 
          width={hintText ? 'auto' : '100%'} 
          widthMobile={hintText ? 'auto' : '100%'} 
          gx={hintText ? 8 : 1} 
          gxMobile={hintText ? 8 : 1} 
        >
          <ContentLabel>
              {label}
          </ContentLabel>
          {hintText && (
            <HintTooltip positionY='top' customStyle={combinedStyle} noDisappearDelay onWhiteBg z={1} text={hintText}>
              <svg className='hint-info-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.1246 10.3409V10.2855C7.13076 9.69768 7.19231 9.22988 7.30926 8.8821C7.42621 8.53433 7.5924 8.25272 7.80784 8.03729C8.02327 7.82185 8.2818 7.62334 8.58341 7.44176C8.76499 7.33097 8.9281 7.20017 9.07275 7.04936C9.2174 6.89548 9.33128 6.71851 9.41437 6.51847C9.50055 6.31842 9.54363 6.09683 9.54363 5.85369C9.54363 5.55208 9.47285 5.29048 9.33128 5.06889C9.1897 4.8473 9.00043 4.67649 8.76345 4.55646C8.52647 4.43643 8.26333 4.37642 7.97403 4.37642C7.72166 4.37642 7.47853 4.42874 7.24463 4.53338C7.01073 4.63802 6.8153 4.80268 6.65834 5.02734C6.50138 5.25201 6.41059 5.54593 6.38596 5.90909H5.22261C5.24723 5.38589 5.38265 4.93809 5.62886 4.5657C5.87815 4.1933 6.20592 3.90862 6.61217 3.71165C7.0215 3.51468 7.47545 3.41619 7.97403 3.41619C8.5157 3.41619 8.98658 3.52391 9.38667 3.73935C9.78985 3.95478 10.1007 4.25024 10.3192 4.62571C10.5408 5.00118 10.6516 5.42898 10.6516 5.90909C10.6516 6.24763 10.5993 6.55386 10.4946 6.82777C10.3931 7.10168 10.2453 7.34635 10.0514 7.56179C9.86063 7.77723 9.62981 7.96804 9.35898 8.13423C9.08814 8.3035 8.87117 8.48201 8.70805 8.66974C8.54494 8.8544 8.42645 9.07446 8.35258 9.3299C8.27872 9.58535 8.23871 9.90388 8.23255 10.2855V10.3409H7.1246ZM7.71551 13.0739C7.48776 13.0739 7.29233 12.9923 7.12922 12.8292C6.9661 12.6661 6.88454 12.4706 6.88454 12.2429C6.88454 12.0152 6.9661 11.8197 7.12922 11.6566C7.29233 11.4935 7.48776 11.4119 7.71551 11.4119C7.94326 11.4119 8.13869 11.4935 8.3018 11.6566C8.46492 11.8197 8.54648 12.0152 8.54648 12.2429C8.54648 12.3937 8.50801 12.5322 8.43106 12.6584C8.3572 12.7846 8.25718 12.8861 8.13099 12.9631C8.00789 13.0369 7.86939 13.0739 7.71551 13.0739Z" fill="#909090"/>
                <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#909090"/>
            </svg>
            </HintTooltip>
          )}
        </CheckBoxInfoWrapper>
    </MagicBox>)
};

  export const Checkbox = styled(PresentationBlockTest)`
  width: 100%;
`

export const PresentationBlock: FC<IPresentation> = ({ 
  currentColor,                                     
  onColorChange,                                                   
  requiredTags,                                                   
  projectTags,
  coAuthors,                                                    
  onSetRequiredTags,
  onSetProjectTags, 
  onCoauthorChange,                                                  
  isModer = false,                                             
  tagEntityRequired,                                                     
  contextRequiredTags,                                    
  organizationEntity,                                                
  errorsArray,                                                 
  errorProjectFill,                                                 
  longReadLength,
  tagEntity,                                              
  vTYPE,                                                 
  title,                                                  
  isBilingual,                                                 
  onToggleBilingual,                                                  
  availability,                                                  
  setAvailability,                                                   
  handleLinkCopy,                                                   
  toggleHideTitle,                                                  
  toggleHideInfo,                                                     
  titleIsHidden,                                                    
  projectInfoIsHidden,
  toggleAgeRestricted,
  additionalContent,
  isAgeRestricted,
  hasCover,
  project,
  incomingType,
  proTags,
  setProTags,
  onAdditionalContentChange,
  onTitlePositionChange,
  titlePosition,
  isTeamProject
  }) => {

    const { i18n } = useTranslation(); // <== добавил это
    const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);
      const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
  useEffect(() => {
    urlApi()
      .getLendPresTagsTree(i18n.language)
      .then((tree: any[]) => {
        const root = tree?.[0] || { additionalTags: [] };
  
        const options = (root.additionalTags || []).map((tag: any) => {
          const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === i18n.language);
          return {
            label: nameObj?.name || tag.title,
            value: tag.tagId,
          };
        });
  
        setProTypeOptions(options);
  
        setNavProTypeValue(prev => {
          if (!prev) return null;
          return options.find((opt: any) => opt.value === prev.value) || null;
        });
      })
      .catch(err => {
        console.error('Не удалось загрузить типы проектов', err);
      });
  }, [i18n.language]);

    useEffect(() => {
      if (incomingType) {
        setProTags([incomingType]);
      }
    }, [incomingType, setProTags]);

    const proTypeValue = useMemo(() => {
      if (proTags) {
        return proTypeOptions.find(({ value }) => value === proTags[0])
      }
    },[proTypeOptions, proTags])

    const setPresentationTag = useCallback((tag: any) => {
        setProTags([tag])
    }, [])

    // @ts-ignore
    const hasEducationalTagInNormalTags = useMemo(() => projectTags?.some(tag => tag?.isEducationTag), [projectTags]);

    const handleToggleBilingualClick = () => onToggleBilingual && onToggleBilingual()

    return (
      <>
        <PresentationWrapper hasCover={hasCover}>
          <PresentationContainer vtype={vTYPE}>
            <CoverSettingsBlock 
              vTYPE={vTYPE}
                  // @ts-ignore
              additionalContent={additionalContent}
              errorsArray={errorsArray}
              coAuthors={coAuthors}
              isBilingual={isBilingual}
              titleIsHidden={titleIsHidden}
              projectInfoIsHidden={projectInfoIsHidden}
              errorProjectFill={errorProjectFill}
              longReadLength={longReadLength}
              onCoauthorChange={onCoauthorChange}
              onAdditionalContentChange={onAdditionalContentChange}
              onTitlePositionChange={onTitlePositionChange}
              titlePosition={titlePosition}
              toggleHideInfo={toggleHideInfo}
              toggleHideTitle={toggleHideTitle}
            />
            <ProjectSettingsBlock 
              vTYPE={vTYPE}
              additionalContent={additionalContent}
              currentColor={currentColor}
              isBilingual={isBilingual}
              proTypeValue={proTypeValue}          
              proTypes={proTypeOptions}                  
              onSetPresentationTag={setPresentationTag}
              coAuthors={coAuthors}
              requiredTags={requiredTags}
              projectTags={projectTags}
              tagEntity={tagEntity}
              availability={availability}
              isAgeRestricted={isAgeRestricted}
              contextRequiredTags={contextRequiredTags}
              hasEducationTag={hasEducationalTagInNormalTags}
              tagEntityRequired={tagEntityRequired}
              onCoauthorChange={onCoauthorChange}
              toggleAgeRestricted={toggleAgeRestricted}
              onAdditionalContentChange={onAdditionalContentChange}
              onBilingualChange={handleToggleBilingualClick}
              onSetRequiredTag={(tag: any) => onSetRequiredTags(tag)}
              onSetProjectTags={(tag: any) => onSetProjectTags(tag)}
              onSetAvailability={setAvailability}
              onCopyLink={handleLinkCopy}
              onColorChange={onColorChange}
              isTeamProject={isTeamProject}
            />
          </PresentationContainer>
        </PresentationWrapper>
      </>
    )
}import { AnchorType, IAddProjectCoverContent, Tag } from '@brg/api';
import React, { FC, useMemo, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { 
  PresentationContainer,
  CheckboxRoot,
  PresentationWrapper,
  ContentLabel,
  CheckBoxInfoWrapper
} from './styles';
import { LayoutConst, } from 'core';
import { OrganizationsState } from 'shared/reducers/OrganizationsSlice';
import { MagicBox, FlexBox, FInter, HintTooltip } from '@brg/ui';
import { ReactComponent as CheckIcon } from "../../../../assets/check.svg";
import { ReactComponent as CheckWhite } from "../../../../assets/checkWhite.svg";
import { ProjectAuthorsChangeCbT } from '../../ProjectAuthorsEdit';
import { AuthorT } from '../../types';
import { ProjectEditPageGridInput } from '_deziiign/books/pages/BookEdit/styles';
import { CoverSettingsBlock } from './sections/CoverSettingsBlock';
import { ProjectSettingsBlock } from './sections/ProjectSettingsBlock';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import urlApi from 'shared/actions/urlApi';
import { useTranslation } from 'react-i18next';

export const INIT_ADDITIONAL_CONTENT: IAddProjectCoverContent = {
  title: {
    text: createDefaultLangObject(''),
    visible: true,
    color: '#000000'
  },
  subtitle: {
    text: createDefaultLangObject(''),
    visible: true,
    color: '#000000'
  },
  button: {
    text: createDefaultLangObject(''),
    color: '#000000',
    bgColor: '#000000',
    href: '',
    visible: false
  },
  anchors: {
    anchorVisible: undefined,
    anchorType: AnchorType.popup
  }
}

export interface IPresentation {
    currentColor: string;
    requiredTags: Tag[];
    projectTags: Tag[];
    isModer?: boolean;
    tagEntityRequired?: string[];
    coAuthors?: AuthorT[];
    contextRequiredTags?: string[];
    tagEntity?: string[];
    errorsArray?: string[];
    errorProjectFill?: boolean;
    longReadLength?: number;
    organizationEntity?: OrganizationsState;
    vTYPE: string;
    title?: any;
    isBilingual: boolean;
    hasCover?: boolean;
    projectTitle?: string;
    toggleHideTitle?: (e: any) => void;
    toggleHideInfo?: (e: any) => void;
    titleIsHidden?: boolean;
    projectInfoIsHidden?: boolean;
    onAdditionalContentChange?: (data: any) => void;
    onTitlePositionChange?: (pos: string) => void;
    titlePosition?: string;
    onCoauthorChange?: (data: ProjectAuthorsChangeCbT) => void;
    onColorChange: (val: string) => void;
    onSetRequiredTags: (tagsRaw: Tag[]) => void;
    onSetProjectTags: (tagsRaw: Tag[]) => void;
    onMakeBilingual?: () => void;
    onDisableBilingual?: () => void;
    onToggleBilingual?: () => void;
    availability?: string;
    additionalContent?: IAddProjectCoverContent,
    setAvailability?: (availability: string) => void;
    handleLinkCopy?: (e: any) => void;
    toggleAgeRestricted?: (e: any) => void;
    isAgeRestricted?: boolean;
    project?: any;
    incomingType?: any;
    proTags: string[],
    isTeamProject?: boolean,
    setProTags: (tagIds: string[]) => void;
}

type MagicBoxRowPropsT = {
    checked: boolean;
    label?: string;
    style?: any;
    onClick?: (ev: React.SyntheticEvent) => void;
    dark?: boolean;
    hintText?: string;
};

export const Footnote = styled(FInter.SmallTextDiv)`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const CopyLinkButton = styled(MagicBox)`
  cursor: pointer;
`

export const DropdownWrapper = styled(FlexBox)`
  ${ProjectEditPageGridInput} {
    width: 100% !important;

    .brg-input__control {
      background-color: #fff !important;
      
      &:hover {
        cursor: pointer;
        border-color: transparent !important;
      }  
    }
    
    input {
      width: 100% !important;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__menu {
      margin-top: 5px;
    }

    .brg-input__indicator {
      padding-top: 5px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s -1}px) {

    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__menu {
      margin-top: 5px;
    }

    .brg-input__indicator {
      padding-top: 5px;
    }
  }
`;


export const PresentationBlockTest: FC<MagicBoxRowPropsT> = ({ onClick, checked, label, style, dark, hintText }) => {

  const baseStyle = { padding: '2px 8px 4px', justifyContent: 'flex-start' };
  const geoStyle ={ background: "#E7E7E7", color: "#70706F", justifyContent: 'flex-start' }

  const combinedStyle = { ...baseStyle, ...geoStyle };

    return (<MagicBox
        onClick={onClick}
        width="100%"
        pointer
        align="center"
        gx={16}
    >
        <CheckboxRoot checked={checked} isProjectPage>
            {checked && (
                <>
                    {dark ? <CheckIcon/> : <CheckWhite/>}
                </>
            )}
            <input checked={checked} type="checkbox"/>
        </CheckboxRoot>
        <CheckBoxInfoWrapper 
          width={hintText ? 'auto' : '100%'} 
          widthMobile={hintText ? 'auto' : '100%'} 
          gx={hintText ? 8 : 1} 
          gxMobile={hintText ? 8 : 1} 
        >
          <ContentLabel>
              {label}
          </ContentLabel>
          {hintText && (
            <HintTooltip positionY='top' customStyle={combinedStyle} noDisappearDelay onWhiteBg z={1} text={hintText}>
              <svg className='hint-info-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.1246 10.3409V10.2855C7.13076 9.69768 7.19231 9.22988 7.30926 8.8821C7.42621 8.53433 7.5924 8.25272 7.80784 8.03729C8.02327 7.82185 8.2818 7.62334 8.58341 7.44176C8.76499 7.33097 8.9281 7.20017 9.07275 7.04936C9.2174 6.89548 9.33128 6.71851 9.41437 6.51847C9.50055 6.31842 9.54363 6.09683 9.54363 5.85369C9.54363 5.55208 9.47285 5.29048 9.33128 5.06889C9.1897 4.8473 9.00043 4.67649 8.76345 4.55646C8.52647 4.43643 8.26333 4.37642 7.97403 4.37642C7.72166 4.37642 7.47853 4.42874 7.24463 4.53338C7.01073 4.63802 6.8153 4.80268 6.65834 5.02734C6.50138 5.25201 6.41059 5.54593 6.38596 5.90909H5.22261C5.24723 5.38589 5.38265 4.93809 5.62886 4.5657C5.87815 4.1933 6.20592 3.90862 6.61217 3.71165C7.0215 3.51468 7.47545 3.41619 7.97403 3.41619C8.5157 3.41619 8.98658 3.52391 9.38667 3.73935C9.78985 3.95478 10.1007 4.25024 10.3192 4.62571C10.5408 5.00118 10.6516 5.42898 10.6516 5.90909C10.6516 6.24763 10.5993 6.55386 10.4946 6.82777C10.3931 7.10168 10.2453 7.34635 10.0514 7.56179C9.86063 7.77723 9.62981 7.96804 9.35898 8.13423C9.08814 8.3035 8.87117 8.48201 8.70805 8.66974C8.54494 8.8544 8.42645 9.07446 8.35258 9.3299C8.27872 9.58535 8.23871 9.90388 8.23255 10.2855V10.3409H7.1246ZM7.71551 13.0739C7.48776 13.0739 7.29233 12.9923 7.12922 12.8292C6.9661 12.6661 6.88454 12.4706 6.88454 12.2429C6.88454 12.0152 6.9661 11.8197 7.12922 11.6566C7.29233 11.4935 7.48776 11.4119 7.71551 11.4119C7.94326 11.4119 8.13869 11.4935 8.3018 11.6566C8.46492 11.8197 8.54648 12.0152 8.54648 12.2429C8.54648 12.3937 8.50801 12.5322 8.43106 12.6584C8.3572 12.7846 8.25718 12.8861 8.13099 12.9631C8.00789 13.0369 7.86939 13.0739 7.71551 13.0739Z" fill="#909090"/>
                <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#909090"/>
            </svg>
            </HintTooltip>
          )}
        </CheckBoxInfoWrapper>
    </MagicBox>)
};

  export const Checkbox = styled(PresentationBlockTest)`
  width: 100%;
`

export const PresentationBlock: FC<IPresentation> = ({ 
  currentColor,                                     
  onColorChange,                                                   
  requiredTags,                                                   
  projectTags,
  coAuthors,                                                    
  onSetRequiredTags,
  onSetProjectTags, 
  onCoauthorChange,                                                  
  isModer = false,                                             
  tagEntityRequired,                                                     
  contextRequiredTags,                                    
  organizationEntity,                                                
  errorsArray,                                                 
  errorProjectFill,                                                 
  longReadLength,
  tagEntity,                                              
  vTYPE,                                                 
  title,                                                  
  isBilingual,                                                 
  onToggleBilingual,                                                  
  availability,                                                  
  setAvailability,                                                   
  handleLinkCopy,                                                   
  toggleHideTitle,                                                  
  toggleHideInfo,                                                     
  titleIsHidden,                                                    
  projectInfoIsHidden,
  toggleAgeRestricted,
  additionalContent,
  isAgeRestricted,
  hasCover,
  project,
  incomingType,
  proTags,
  setProTags,
  onAdditionalContentChange,
  onTitlePositionChange,
  titlePosition,
  isTeamProject
  }) => {

    const { i18n } = useTranslation(); // <== добавил это
    const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);
      const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
  useEffect(() => {
    urlApi()
      .getLendPresTagsTree(i18n.language)
      .then((tree: any[]) => {
        const root = tree?.[0] || { additionalTags: [] };
  
        const options = (root.additionalTags || []).map((tag: any) => {
          const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === i18n.language);
          return {
            label: nameObj?.name || tag.title,
            value: tag.tagId,
          };
        });
  
        setProTypeOptions(options);
  
        setNavProTypeValue(prev => {
          if (!prev) return null;
          return options.find((opt: any) => opt.value === prev.value) || null;
        });
      })
      .catch(err => {
        console.error('Не удалось загрузить типы проектов', err);
      });
  }, [i18n.language]);

    useEffect(() => {
      if (incomingType) {
        setProTags([incomingType]);
      }
    }, [incomingType, setProTags]);

    const proTypeValue = useMemo(() => {
      if (proTags) {
        return proTypeOptions.find(({ value }) => value === proTags[0])
      }
    },[proTypeOptions, proTags])

    const setPresentationTag = useCallback((tag: any) => {
        setProTags([tag])
    }, [])

    // @ts-ignore
    const hasEducationalTagInNormalTags = useMemo(() => projectTags?.some(tag => tag?.isEducationTag), [projectTags]);

    const handleToggleBilingualClick = () => onToggleBilingual && onToggleBilingual()

    return (
      <>
        <PresentationWrapper hasCover={hasCover}>
          <PresentationContainer vtype={vTYPE}>
            <CoverSettingsBlock 
              vTYPE={vTYPE}
                  // @ts-ignore
              additionalContent={additionalContent}
              errorsArray={errorsArray}
              coAuthors={coAuthors}
              isBilingual={isBilingual}
              titleIsHidden={titleIsHidden}
              projectInfoIsHidden={projectInfoIsHidden}
              errorProjectFill={errorProjectFill}
              longReadLength={longReadLength}
              onCoauthorChange={onCoauthorChange}
              onAdditionalContentChange={onAdditionalContentChange}
              onTitlePositionChange={onTitlePositionChange}
              titlePosition={titlePosition}
              toggleHideInfo={toggleHideInfo}
              toggleHideTitle={toggleHideTitle}
            />
            <ProjectSettingsBlock 
              vTYPE={vTYPE}
              additionalContent={additionalContent}
              currentColor={currentColor}
              isBilingual={isBilingual}
              proTypeValue={proTypeValue}          
              proTypes={proTypeOptions}                  
              onSetPresentationTag={setPresentationTag}
              coAuthors={coAuthors}
              requiredTags={requiredTags}
              projectTags={projectTags}
              tagEntity={tagEntity}
              availability={availability}
              isAgeRestricted={isAgeRestricted}
              contextRequiredTags={contextRequiredTags}
              hasEducationTag={hasEducationalTagInNormalTags}
              tagEntityRequired={tagEntityRequired}
              onCoauthorChange={onCoauthorChange}
              toggleAgeRestricted={toggleAgeRestricted}
              onAdditionalContentChange={onAdditionalContentChange}
              onBilingualChange={handleToggleBilingualClick}
              onSetRequiredTag={(tag: any) => onSetRequiredTags(tag)}
              onSetProjectTags={(tag: any) => onSetProjectTags(tag)}
              onSetAvailability={setAvailability}
              onCopyLink={handleLinkCopy}
              onColorChange={onColorChange}
              isTeamProject={isTeamProject}
            />
          </PresentationContainer>
        </PresentationWrapper>
      </>
    )
}